import { initializeApp } from 'firebase/app';
import { getConfig } from '../config';

import { getFirestore } from 'firebase/firestore';
import { getAuth } from 'firebase/auth';
import { getStorage } from 'firebase/storage';

const firebaseConfig = getConfig('FIREBASE_CONFIG');

if (!window.firebase?.apps?.length) {
  initializeApp(firebaseConfig);
}

export const auth = getAuth(window.firebase?.apps?.[0]);
export const firestore = getFirestore(window.firebase?.apps?.[0]);
export const storage = getStorage(window.firebase?.apps?.[0]);

const main = { auth, firestore, storage };

export default main;
